import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {BannerComponent} from './banner/banner.component';
import {AboutCompanyComponent} from './about-company/about-company.component';
import {PartnersComponent} from './partners/partners.component';
import {ProductsComponent} from './products/products.component';
import {ArticlesComponent} from './articles/articles.component';
import {RewardsComponent} from './rewards/rewards.component';
import {FooterComponent} from './footer/footer.component';
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import { CookieWarnComponent } from './cookie-warn/cookie-warn.component';
import {ModalWindowComponent} from './products/modal-window/modal-window.component';


@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    AboutCompanyComponent,
    PartnersComponent,
    ProductsComponent,
    ArticlesComponent,
    RewardsComponent,
    FooterComponent,
    CookieWarnComponent,
    ModalWindowComponent,
  ],
  imports: [
    BrowserModule,
    AngularMyDatePickerModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
